import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Transactions_Questions_Object|Transactions_Questions_Is} state
 *  @property {object} model
 *  @property {Transactions_Questions_Properties} model.properties
 *  @property {Transactions_Questions_Is} model.is
 *  @property {Transactions_Questions_Has} model.has
 */
export default class ReservationEligibility extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		questions: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Transactions_Questions._name);

		this.state.us_citizen = true;
		// TBD: does this value need to be used?
		this.state.actual_transferee = false;
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.setState({pkey: data.pkey});
	}

	form = () => {
		/** @type {Transactions_Questions_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Questions_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset disabled={!!this.state.pkey}>
					<h4 className="section-title">Eligibility Questions</h4>

					<span>The following questions are taken from Form 4 Section 14.a - 14.h and 16.a - 17. The identical questions are found on Form
						23 Section 6.a - 8. Form 5 Section 13 - 14 has the same question except where differences have been noted in italics. See the
						forms for additional clarification on questions including definitions.
					</span>
					<hr/>

					{/*#region 14a felony_indictment*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Are you under indictment or information in any court for a <b>felony</b>, or any other crime, for which the judge
								could imprison you for more than one year?
								<i>
									Form 5 alternative wording, "Are you charged by information or under
									indictment in any court for a crime punishable by
									imprisonment for a term exceeding one year?"
								</i>
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.felony_indictment}
									value={object.felony_indictment}
									error={object.felony_indictment_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14b felony_convicted*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Have you ever been convicted in any court of a <b>felony</b>, or any other
								crime, for which the judge could have imprisoned you for more than one year, even if
								you received a shorter sentence including probation?
								<i>
									Form 5 alternative wording, "Have you been convicted in any
									court of a crime for which the judge could of imprisoned you for more than one year, even if the judge actually
									gave
									you a shorter sentence?"
								</i>
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.felony_convicted}
									value={object.felony_convicted}
									error={object.felony_convicted_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14c fugitive*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Are you a fugitive from justice?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.fugitive}
									value={object.fugitive}
									error={object.fugitive_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14d drug_user*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>

								Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any
								other controlled substance? <b>Warning: The use or possession of marijuana remains unlawful
								under Federal law regardless of whether it has been legalized or decriminalized for medicinal or
								recreational purposes in the state where you reside.</b>

							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.drug_user}
									value={object.drug_user}
									error={object.drug_user_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14e mentally_stable*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Have you ever been adjudicated as a mental defective <b>OR</b> have you ever been committed to a mental
								institution?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.mentally_stable}
									value={object.mentally_stable}
									error={object.mentally_stable_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14f dishonorable_discharge*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Have you been discharged from the Armed Forces under <b>dishonorable</b> conditions?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.dishonorable_discharge}
									value={object.dishonorable_discharge}
									error={object.dishonorable_discharge_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14g restraining_order*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Are you subject to a court order restraining you from harassing, stalking, or threatening your child or an
								intimate partner or child of such partner?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.restraining_order}
									value={object.restraining_order}
									error={object.restraining_order_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 14h domestic_violence*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Have you ever been convicted in any court of a misdemeanor crime of domestic violence?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.domestic_violence}
									value={object.domestic_violence}
									error={object.domestic_violence_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 18a us_citizen*/}

					<div className={'row'}>
						<div className={'col-sm-8'}>
							<p>
								Country of Citizenship:
							</p>
						</div>
						<div className={`col-sm-${object.us_citizen ? 4 : 2} text-right`}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.us_citizen}
									value={object.us_citizen}
									error={object.us_citizen_error}
									update={this.handleTextFieldPropertyUpdate}
									labelTrue={'U.S.'}
									labelFalse={'Other'}
								/>
							</div>
						</div>
						{object.us_citizen === false &&
						<div className={'col-sm-2 text-right'}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.country_of_citizenship}
									value={object.country_of_citizenship}
									error={object.country_of_citizenship_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						}
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 18d renounced_citizenship*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Have you ever renounced your United States citizenship?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.renounced_citizenship}
									value={object.renounced_citizenship}
									error={object.renounced_citizenship_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 18e illegal_alien*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Are you an alien illegally or unlawfully in the United States?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.illegal_alien}
									value={object.illegal_alien}
									error={object.illegal_alien_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 18f1 nonimmigrant_visa*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Are you an alien who has been admitted to the United States under a nonimmigrant visa?
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.nonimmigrant_visa}
									value={object.nonimmigrant_visa}
									error={object.nonimmigrant_visa_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region 18f2 fall_within_exceptions*/}

					{object.nonimmigrant_visa &&
					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								12.d.2. If "yes", do you fall within any of the exceptions state in the
								instructions?
							</p>
						</div>

						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.fall_within_exceptions}
									value={object.fall_within_exceptions}
									error={object.fall_within_exceptions_error}
									update={this.handleTextFieldPropertyUpdate}
									autoSelect={false}
								/>
							</div>
						</div>
					</div>
					}

					{/*#endregion*/}

					{/*#region 19 alien_number*/}

					<div className={'row'}>
						<div className={'col-sm-8'}>
							<p>
								If you are an alien, record your U.S.-Issued Alien or Admission number (AR#, USCIS#, or 194#):
							</p>
						</div>
						<div className={'col-sm-4 text-right'}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.alien_or_admission_number}
									value={object.alien_or_admission_number}
									error={object.alien_or_admission_number_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Number'}
								/>
							</div>
						</div>
					</div>
					<hr/>

					{/*#endregion*/}

					{/*#region  under_twenty_one*/}

					<div className={'row'}>
						<div className={'col-sm-9'}>
							<p>
								Under 21 years of age * Only required for Form 5
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={properties.under_twenty_one}
									value={object.under_twenty_one}
									error={object.under_twenty_one_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>

					{/*#endregion*/}

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		if (this.state.pkey) {
			return (
				<Card style={{overflow: 'visible'}}>
					<CardContent>
						{this.form()}
					</CardContent>
				</Card>
			)
		} else {
			return (
				<Card style={{overflow: 'visible'}}>
					<CardContent style={{paddingBottom: 0}}>
						{this.form()}
						<hr style={{marginBottom: 0}}/>
					</CardContent>
					<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
						<Button color="danger" onClick={this.handleDelete}>Delete</Button>
						<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					</CardActions>
				</Card>
			)
		}
	}
}
